import React from 'react';

import { useForm } from 'components/form';
import { RHP } from 'providers';
import * as Page from 'components/page';

import { EcosystemStep2AddForm } from './EcosystemStep2AddForm';

export function EcosystemStep2Add(props) {
    const { postUserRelationship } = props.useRankingEcosystem;
    const currDate = new Date();

    const [skip, setSkip] = React.useState(false);

    // Initialize a new form handler
    const form = useForm({
        year: currDate.getFullYear(),
        otherContact: false,
    });

    // Custom onChange events
    const onChange = {
        startup: () => {
            setSkip(false);
            form.emitError({ name: 'startup', error: undefined });
        },
    };

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            year: values.year,
            programName: values.programName,
            description: values.description,
            linkUrl: values.linkUrl,
            rankings: { '2020': true },
        };
        // Add company
        if (values.companyName) {
            payload.company = {
                name: values.companyName,
            };
        }
        // Add startup trough id
        if (values.startup && values.startup._id) {
            payload.startupId = values.startup._id;
        }
        // Add startup contact information
        if (values.startupName && values.contactName && values.contactEmail) {
            payload.startup = {
                name: values.startupName,
                contact: {
                    name: values.contactName,
                    email: values.contactEmail,
                },
            };
        }
        return postUserRelationship(payload)
            .then(() => RHP.push('/ranking/ecosystem/step2'))
            .catch(() => form.submited());
    };

    const propsForm = { ...props, form, skip, setSkip, onChange, onSubmit };
    return (
        <Page.Page name="EcosystemStep2Add">
            <Page.Title>{props.t('EcosystemStep2Add.title')}</Page.Title>
            <Page.Descr>{props.t('EcosystemStep2Add.descr')}</Page.Descr>

            <EcosystemStep2AddForm {...propsForm} />
        </Page.Page>
    );
}
export default EcosystemStep2Add;
